export default __webpack_public_path__ + "static/media/daet-favorite.806362fe.png";